import { basePath, apiVersion } from "./config";


export function signInApi(data) {
    const url = `${basePath}/${apiVersion}/sign-in`;
    const params = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    };
  
    return fetch(url, params)
      .then(response => {
        return response.json();
      })
      .then(result => {
  
        return result;
      })
      .catch(err => {
        return err.message;
      });
  }
  

  export async function getMe(accessToken) {
    try {
      const url = `${basePath}/${apiVersion}/user/me`;
      const params = {
        headers: {
          Authorization: `${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
  export async function UpdatePasswordApi(accessToken, usuario) {
    try {
      const url = `${basePath}/${apiVersion}/user/change`;
      const params = {
        method: 'PUT', // Cambiado a POST
        headers: {
          'Content-Type': 'application/json', // Añadido encabezado Content-Type
          Authorization: `${accessToken}`,
        },
        body: JSON.stringify(usuario),
      };
  
      const response = await fetch(url, params);
      const result = await response.json();
  
      if (response.status !== 200) throw result;
  
      return result;
    } catch (error) {
      throw error;
    }
  }
  
  